import { EMPTY, Observable, map, merge, mergeMap, startWith, tap } from "@suse-o11y/rxjs";
import type { Location } from "history";
import type { AnyAction } from "redux";
import type { Epic } from "redux-observable";

import { DO_NOT_USED_IT_OR_YOU_ARE_FIRED_navigateFromLink } from "../../../components/react/link";
import { typedStream } from "../../../generic/redux/TypedRedux";
import { COMPONENT_PATH, VIEW_PATH } from "../../../routes/Routes";
import type { EpicDependencies } from "../ReduxStore";
import type { RootState } from "../RootState";

import { type MergeViewParams, storeLocation } from "./RouteActions";
import { MERGE_VIEW_PARAMS } from "./RouteActionTypes";
import { selectCurrentLocation } from "./RouteSelectors";

export const MergeViewParamsEpic: Epic<AnyAction, AnyAction, RootState, EpicDependencies> = (
	actions,
	states,
	{ history },
) =>
	merge(
		// Programmatically navigate by pushing locations into browser history
		actions.pipe(
			typedStream<MergeViewParams>(MERGE_VIEW_PARAMS),
			tap(({ mode, search }) => {
				const url = DO_NOT_USED_IT_OR_YOU_ARE_FIRED_navigateFromLink(
					{
						location: selectCurrentLocation(states.value),
						middleware: [],
					},
					[VIEW_PATH, COMPONENT_PATH],
					{
						params: (currentParams) => ({
							...currentParams,
							mode: mode ?? currentParams.mode,
						}),
						search: (currentSearch) => ({
							...currentSearch,
							...search,
						}),
					},
				);

				if (url != null) {
					history.push(url);
				}
			}),
			mergeMap(() => EMPTY),
		),
		// Once the history is changed either by this epic or by any other way, push StoreLocation actions to update redux
		new Observable<Location>((subscriber) => history.listen((location) => subscriber.next(location))).pipe(
			map(storeLocation),
		),
	).pipe(startWith(storeLocation(history.location)));
